export const permission = {
  READ_ORG_SETUP: 'R_ORG',
  WRITE_ORG_SETUP: 'RW_ORG',
  WRITE_USER: 'RW_USER',
  READ_BNY: 'R_BNYTCRT',
  WRITE_BNY: 'RW_BNYTCRT',
};
